import script from "./QuestionTagSelectorByBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionTagSelectorByBlock.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__